import { Injectable } from '@angular/core';
var MapsAPILoader = (function () {
    function MapsAPILoader() {
    }
    return MapsAPILoader;
}());
export { MapsAPILoader };
MapsAPILoader.decorators = [
    { type: Injectable },
];
/** @nocollapse */
MapsAPILoader.ctorParameters = function () { return []; };
//# sourceMappingURL=maps-api-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@agm/core/services/maps-api-loader/maps-api-loader.js
// module id = 25
// module chunks = 3